import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';
import { allArticles } from '@/mocks/articles';

const articleDetailImages: Record<string, string> = {
  'ding-liu-nan-xing-qian-gui-ze-nei-mu': 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20stage%20with%20a%20single%20spotlight%20on%20an%20empty%20director%20chair%2C%20atmospheric%20mysterious%20mood%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20film%20noir%20style%2C%20minimalist%20composition%2C%20warm%20amber%20spotlight%20against%20dark%20background&width=1400&height=700&seq=detail-dingliu&orientation=landscape',
  'qian-wan-fen-wang-hong-bei-pin-pai-jie-yue': 'https://readdy.ai/api/search-image?query=A%20shattered%20smartphone%20screen%20on%20a%20dark%20table%20with%20broken%20glass%20scattered%2C%20dramatic%20red%20and%20black%20lighting%2C%20chaotic%20atmosphere%2C%20dark%20cinematic%20mood%2C%20editorial%20photography&width=1400&height=700&seq=detail-wanghong&orientation=landscape',
  'zhi-ming-dao-yan-bei-zhi-kong-xing-sao-rao': 'https://readdy.ai/api/search-image?query=An%20empty%20film%20set%20with%20professional%20camera%20equipment%20silhouetted%20against%20dark%20studio%20background%2C%20cerie%20atmosphere%2C%20single%20overhead%20light%20casting%20shadows%2C%20cinematic%20composition&width=1400&height=700&seq=detail-daoyan&orientation=landscape',
  'nv-tuan-cheng-yuan-lian-ai-bao-guang': 'https://readdy.ai/api/search-image?query=Dark%20alley%20at%20night%20with%20blurred%20couple%20silhouette%20walking%20together%2C%20paparazzi%20hidden%20camera%20style%2C%20grainy%20cinematic%20texture%2C%20warm%20amber%20street%20lamp%20glow%2C%20mysterious%20voyeuristic%20mood%2C%20high%20contrast%20editorial%20photography&width=1400&height=700&seq=detail-nvtuan&orientation=landscape',
  'zhu-bo-kao-yan-zhuang-che': 'https://readdy.ai/api/search-image?query=Burning%20fake%20diploma%20with%20bright%20orange%20flames%20on%20dark%20surface%2C%20dramatic%20fire%20lighting%20casting%20long%20shadows%2C%20symbolic%20of%20exposed%20academic%20fraud%2C%20intense%20cinematic%20composition%2C%20dark%20background%2C%20editorial%20photography&width=1400&height=700&seq=detail-kaoyan&orientation=landscape',
  'ding-liu-hua-dan-zheng-fan-wei-da-zhan': 'https://readdy.ai/api/search-image?query=Two%20intense%20spotlights%20crossing%20and%20clashing%20dramatically%20in%20dark%20theater%20space%2C%20warm%20amber%20vs%20cool%20blue%20lighting%20contrast%2C%20dramatic%20confrontation%20metaphor%2C%20cinematic%20atmosphere%2C%20abstract%20powerful%20composition&width=1400&height=700&seq=detail-huadan&orientation=landscape',
  'jie-mu-zu-bao-liao-tou-piao-zuo-jia': 'https://readdy.ai/api/search-image?query=Tampered%20voting%20ballot%20box%20under%20dramatic%20interrogation%20lighting%2C%20shadowy%20hands%20manipulating%20papers%20in%20darkness%2C%20corrupt%20atmosphere%2C%20film%20noir%20aesthetic%2C%20high%20contrast%20deep%20red%20and%20black%20tones%2C%20editorial%20photography&width=1400&height=700&seq=detail-xuanxiu&orientation=landscape',
  'zhi-ming-zhu-bo-tao-shui-bei-fa': 'https://readdy.ai/api/search-image?query=Abandoned%20luxurious%20livestreaming%20studio%20with%20dim%20emergency%20lights%2C%20expensive%20products%20left%20scattered%20on%20desk%2C%20cerie%20silent%20atmosphere%2C%20cold%20dark%20mood%2C%20cinematic%20wide%20shot%20composition%2C%20editorial%20photography&width=1400&height=700&seq=detail-taoshui&orientation=landscape',
  'yi-xian-nan-xing-hun-wai-qing-bao-guang': 'https://readdy.ai/api/search-image?query=Shattered%20wedding%20ring%20on%20dark%20marble%20surface%20with%20dramatic%20side%20lighting%2C%20deep%20shadows%2C%20symbolic%20of%20broken%20marriage%20and%20betrayal%2C%20melancholic%20heavy%20atmosphere%2C%20high%20contrast%20editorial%20photography&width=1400&height=700&seq=detail-hunwai&orientation=landscape',
  'wang-luo-ge-shou-chao-xi-feng-bo': 'https://readdy.ai/api/search-image?query=Two%20golden%20musical%20notes%20colliding%20and%20shattering%20into%20fragments%20mid%20air%20against%20dramatic%20dark%20background%2C%20warm%20amber%20and%20crimson%20accents%2C%20symbolic%20of%20music%20plagiarism%20controversy%2C%20cinematic%20editorial%20composition&width=1400&height=700&seq=detail-chaoxi&orientation=landscape',
  'zong-yi-jie-mu-hei-mu-jie-mi': 'https://readdy.ai/api/search-image?query=Dark%20television%20show%20backstage%20with%20manipulated%20script%20pages%20scattered%20and%20puppet%20strings%20hanging%20from%20ceiling%2C%20dramatic%20film%20noir%20lighting%2C%20mysterious%20corrupt%20atmosphere%2C%20high%20contrast%20editorial%20photography&width=1400&height=700&seq=detail-zongyi&orientation=landscape',
  'duan-shi-pin-hong-ren-bei-bao-jia-bao': 'https://readdy.ai/api/search-image?query=Cracked%20family%20photo%20frame%20lying%20on%20dark%20wooden%20floor%2C%20dramatic%20shadow%20lighting%20from%20single%20window%2C%20melancholic%20heavy%20atmosphere%2C%20symbolic%20of%20domestic%20violence%20revelation%2C%20cinematic%20emotional%20composition&width=1400&height=700&seq=detail-jiabao&orientation=landscape',
  'ming-xing-kai-wang-hong-dian-bei-zhi-jia-ge-xu-gao': 'https://readdy.ai/api/search-image?query=Luxurious%20restaurant%20table%20with%20overpriced%20dishes%20under%20dim%20dramatic%20overhead%20lighting%2C%20empty%20chairs%20surrounding%20abandoned%20meal%2C%20dark%20cynical%20mood%2C%20editorial%20photography%2C%20high%20contrast%20film%20noir%20aesthetic&width=1400&height=700&seq=detail-canting&orientation=landscape',
  'jing-dian-xing-sao-rao-an-jian-pan-dian': 'https://readdy.ai/api/search-image?query=Timeline%20of%20newspaper%20clippings%20pinned%20on%20dark%20cork%20board%20wall%2C%20dramatic%20investigative%20journalism%20lighting%2C%20warm%20amber%20desk%20lamp%20glow%2C%20noir%20atmosphere%2C%20dusty%20historical%20archive%20aesthetic%2C%20editorial%20photography&width=1400&height=700&seq=detail-jingdian1&orientation=landscape',
  'wang-hong-jing-ji-xia-de-fan-che-shi-jian': 'https://readdy.ai/api/search-image?query=Collapsed%20house%20of%20cards%20made%20of%20social%20media%20platform%20icons%20falling%20apart%2C%20dramatic%20spotlight%20lighting%2C%20powerful%20metaphor%20for%20influencer%20career%20downfall%2C%20dark%20cinematic%20background%2C%20editorial%20photography&width=1400&height=700&seq=detail-jingdian2&orientation=landscape',
  'ming-xing-tao-shui-an-jian-zong-he': 'https://readdy.ai/api/search-image?query=Tall%20stack%20of%20tax%20documents%20and%20financial%20records%20under%20dramatic%20interrogation%20room%20spotlight%2C%20dark%20investigative%20atmosphere%2C%20film%20noir%20style%2C%20high%20contrast%20shadows%2C%20editorial%20photography%20quality&width=1400&height=700&seq=detail-jingdian3&orientation=landscape',
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = allArticles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-heading font-black text-foreground-950 mb-4">文章未找到</h1>
          <Link to="/" className="text-primary-500 hover:text-primary-600 font-medium">返回首页</Link>
        </div>
      </div>
    );
  }

  const relatedArticles = allArticles
    .filter((a) => a.categorySlug === article.categorySlug && a.slug !== article.slug)
    .slice(0, 3);

  const articleSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        'headline': article.title,
        'description': article.excerpt,
        'datePublished': article.date,
        'author': {
          '@type': 'Organization',
          'name': '黑料六点半编辑部',
        },
        'publisher': {
          '@type': 'Organization',
          'name': '黑料六点半',
          'url': 'https://www.heilia630.com/',
        },
        'image': articleDetailImages[article.slug] || '',
        'url': `https://www.heilia630.com/article/${article.slug}`,
        'mainEntityOfPage': {
          '@type': 'WebPage',
          '@id': `https://www.heilia630.com/article/${article.slug}`,
        },
        'inLanguage': 'zh-CN',
        'about': {
          '@type': 'Thing',
          'name': article.category,
        },
      },
      {
        '@type': 'BreadcrumbList',
        'itemListElement': [
          { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'https://www.heilia630.com/' },
          { '@type': 'ListItem', 'position': 2, 'name': article.category, 'item': `https://www.heilia630.com/category/${article.categorySlug}` },
          { '@type': 'ListItem', 'position': 3, 'name': article.title },
        ],
      },
    ],
  };

  const paragraphs = [
    article.excerpt,
    '据多位知情人士向本网透露，该事件在圈内早已有传闻，但一直未被公开报道。随着更多细节浮出水面，事件的真相逐渐清晰。多位业内人士在接受采访时表示，此类现象在娱乐圈并非个例。',
    '一位不愿透露姓名的业内人士告诉本网："这种情况已经持续很久了，只是大家都不敢说。现在终于有人站出来了，这是一个好的开始。"',
    '事件曝光后，相关话题迅速登上各大社交平台热搜榜。截至发稿前，相关话题阅读量已突破5亿，讨论量超过200万条。网友纷纷在评论区表达震惊与愤怒。',
    '有法律界人士指出，如果爆料内容属实，涉案人员可能面临严重的法律后果。同时，受害者的权益保护问题也引发了广泛讨论。',
    '目前，涉事方尚未对此事做出正式回应。本网将持续关注事件进展，为读者带来最新报道。',
    '本文由黑料六点半编辑部综合报道。我们将继续秉持"吃瓜无罪，八卦有理"的理念，为读者提供真实的娱乐圈资讯。同时提醒广大读者，理性吃瓜，不传谣不信谣。',
  ];

  return (
    <>
      <SEOHead
        title={article.title}
        description={article.excerpt}
        keywords={`${article.category},${article.title},黑料六点半,51黑料,吃瓜,八卦,娱乐圈`}
        canonicalUrl={`/article/${article.slug}`}
        ogType="article"
        schema={articleSchema}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <div className="pt-16">
            <div className="relative h-[350px] md:h-[500px] overflow-hidden">
              <img
                src={articleDetailImages[article.slug] || ''}
                alt={article.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/70"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10 max-w-4xl mx-auto">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold mb-3">
                  {article.category}
                </span>
                <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-black text-background-50 leading-tight text-balance">
                  {article.title}
                </h1>
              </div>
            </div>

            <div className="max-w-4xl mx-auto px-4 md:px-6 py-8">
              <Breadcrumb
                items={[
                  { label: '首页', path: '/' },
                  { label: article.category, path: `/category/${article.categorySlug}` },
                  { label: article.title },
                ]}
              />

              <div className="flex items-center gap-4 py-6 border-b border-background-200/70 mb-8">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-user-line text-primary-600"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">黑料六点半编辑部</p>
                    <p className="text-xs text-foreground-400">{article.date} · 独家爆料</p>
                  </div>
                </div>
                <div className="ml-auto flex items-center gap-4 text-sm text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views} 阅读
                  </span>
                </div>
              </div>

              <article className="prose-custom">
                {paragraphs.map((para, index) => (
                  <p key={index} className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6">
                    {para}
                  </p>
                ))}
              </article>

              <div className="mt-10 p-6 bg-background-100 rounded-2xl border border-background-200/70">
                <p className="text-sm text-foreground-500 text-center">
                  <strong className="text-foreground-700">声明：</strong>
                  本文内容来源于公开信息及可靠线人爆料，仅供读者参考。
                  对于未经法律程序确认的内容，请读者理性看待，不传谣不信谣。
                  如有不实之处，欢迎联系编辑部核实更正。
                </p>
              </div>

              {relatedArticles.length > 0 && (
                <div className="mt-14">
                  <h2 className="text-2xl font-heading font-black text-foreground-950 mb-6">
                    相关<span className="text-primary-500">爆料</span>
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {relatedArticles.map((related) => (
                      <Link
                        key={related.slug}
                        to={`/article/${related.slug}`}
                        className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                      >
                        <div className="relative h-36 overflow-hidden">
                          <img
                            src={articleDetailImages[related.slug] || ''}
                            alt={related.title}
                            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                          />
                        </div>
                        <div className="p-4">
                          <h3 className="text-sm font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2">
                            {related.title}
                          </h3>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}